<template>
  <class-detail-section class="teacher-section-info" title="Teacher Skill Information">
    <template #actions>
      <button
        v-if="teacherProfile.can_edit"
        class="teacher-section-info__edit-button"
        @click="editSkill"
        data-test-id="edit-skill-button"
      >
        <span class="teacher-section-info__edit-icon">
          <font-awesome-icon :icon="['fas', 'edit']" />
        </span>
      </button>
    </template>

    <div class="teacher-skill">
      <div class="teacher-section-info__split-col">
        <span class="teacher-section-info__label-title">ALSO SPEAK</span>
        <div
          class="teacher-section-info__data-item"
          v-for="speak in teacherProfile.speaking_languages"
          :key="speak.code"
          data-test-id="speaking-language"
        >
          <span class="teacher-section-info__label">{{ speak.name }}</span>
          <div class="teacher-section-info__value">{{ speak.level }}</div>
        </div>
        <hr />
        <span class="teacher-section-info__label-title">THE TEACHER IS FAMILIAR WITH</span>
        <div class="teacher-section-info__data-list" data-test-id="selected-topics">
          <span v-for="topic in teacherProfile.selected_topics" :key="topic">{{ topic }}, </span>
        </div>
        <hr />
        <span class="teacher-section-info__label-title">INDUSTRIES</span>
        <div class="teacher-section-info__data-list" data-test-id="selected-industries">
          <span v-for="topic in teacherProfile.selected_industries" :key="topic">{{ topic }}, </span>
        </div>
      </div>
      <hr />
      <div class="teacher-section-info__split-col">
        <span class="teacher-section-info__label-title">TEACHER FLAGS</span>
        <div class="teacher-section-info__data-item">
          <span class="teacher-section-info__label">EU recognized certifications</span>
          <div class="teacher-section-info__value">
            {{ teacherProfile.has_certification_eu_recognized ? 'yes' : 'no' }}
          </div>
        </div>
        <template v-if="restrictedSectionVisible">
          <div class="teacher-section-info__data-item">
            <span class="teacher-section-info__label">NATIVE</span>
            <div class="teacher-section-info__value">
              {{ teacherProfile.has_flag_native ? 'yes' : 'no' }}
            </div>
          </div>
          <div class="teacher-section-info__data-item">
            <span class="teacher-section-info__label">DEMO</span>
            <div class="teacher-section-info__value">
              {{ teacherProfile.has_flag_demo ? 'yes' : 'no' }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </class-detail-section>
</template>

<script>
import ClassDetailSection from '@/views/classes/components/ClassDetailSection';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ModalTeacherSkillInfo from './forms/ModalTeacherSkillInfo';
import constants from './forms/constants';

export default {
  name: 'TeacherSkillInfo',

  components: {
    ClassDetailSection,
    FontAwesomeIcon,
  },

  props: {
    teacherProfile: {
      type: Object,
      required: true,
    },
    restrictedSectionVisible: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    editSkill() {
      this.$modal.show(
        ModalTeacherSkillInfo,
        ...constants.modalConfig(this, { restrictedSectionVisible: this.restrictedSectionVisible }),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';
@import '~styles/components/teacher-management-sections';
</style>
